import { useState } from "react";
import styles from "./MembersTab.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";

import RemoveAllModal from "../RemoveAllModal";
import Card from "../Card";
import SearchCard from "../SearchCard";
import MembersList from "../MembersList";

/**
 *
 *  the contents under the tab bar in the Members tab of the group page
 *
 */

export function MembersTab({}) {
  const [removeAllModalOpen, setRemoveAllModalOpen] = useState(false);

  var placeholderMembers = [
    {
      iboName: "liboName",
      iboNum: "0000000000",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "kiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "jiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "hiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "giboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "fiboName",
      iboNum: "0000000000",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "diboName",
      iboNum: "0000000000",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "siboName",
      iboNum: "0000000000",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "aiboName",
      iboNum: "0000000000",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "qiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "wiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "eiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "eiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "riboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "tiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "yiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "uiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "iiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "oiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "piboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "ziboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "xiboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "ciboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "viboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "biboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "niboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "miboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "iboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "iboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "iboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "iboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "iboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "iboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "iboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "iboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
    {
      iboName: "iboName",
      iboNum: "iboNum",
      pluginId: "pluginId",
      asAdmin: true,
      pluginType: "pluginType",
    },
  ];

  function removeAllMembers() {
    alert("removeAllMembers called");
    setRemoveAllModalOpen(false);
  }

  return (
    <div className={styles.container}>
      <div className={styles.cardContainer}>
        <Card
          title={"NON-LOS MEMBERS"}
          buttonName="REMOVE ALL"
          onClick={() => setRemoveAllModalOpen(true)}
          children={
            <div className={styles.memberListContainer}>
              <MembersList members={placeholderMembers} empty={true} />
            </div>
          }
        />
      </div>

      <div className={styles.cardContainer}>
        <SearchCard
          title="MEMBERS FOR LOS"
          iboInfos={placeholderMembers}
          empty={true}
        />
      </div>
      <div className={styles.cardContainer}>
        <SearchCard
          title="MEMBERS FOR PLUGIN"
          iboInfos={placeholderMembers}
          empty={false}
        />
      </div>
      <div className={styles.cardContainer}>
        <SearchCard
          title="MISSING MEMBERS"
          iboInfos={placeholderMembers}
          empty={true}
        />
      </div>

      <RemoveAllModal
        isOpen={removeAllModalOpen}
        onClose={() => setRemoveAllModalOpen(false)}
        onClick={removeAllMembers}
        ibos={placeholderMembers}
      />
    </div>
  );
}

MembersTab.propTypes = {};
